import { render, staticRenderFns } from "./ContestRef.vue?vue&type=template&id=5ff56152&"
import script from "./ContestRef.vue?vue&type=script&lang=js&"
export * from "./ContestRef.vue?vue&type=script&lang=js&"
import style0 from "./ContestRef.vue?vue&type=style&index=0&id=5ff56152&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports